import { defineStore } from 'pinia';
import { GET_SEARCH_REGISTRY_RESULTS } from '~/types/actions';
import {
  SET_SEARCH_REGISTRY_RESULTS,
  SET_REGISTRY_RESULTS_TABLE_VISIBILITY,
  SET_SELECTED_REGISTRY_ID,
  SET_REGISTRY_REDIRECT_SEARCH_TERM,
  SET_REGISTRY_RESULTS_LOADING,
  SET_SEARCH_REGISTRY_ERROR_STATE,
  SET_REGISTRY_SEARCH_TERM,
  SEARCH_REGISTRY_API_ERROR_RESPONSE,
  SET_GIFTGIVER_TO_SEARCHPAGE,
  SET_SEARCH_TO_GIFTGIVERPAGE,
  SET_SELECTED_REGISTRY_GUID,
  SET_REGISTRY_SEARCH_OCCASION,
} from '~/types/mutations';
import { validateRegistryId } from '~/utils/SearchRegistryUtil';
import { httpGetNonProtectedAPIHeaders } from '~/utils/APIUtil';
import $http from '@vue-util/http';
import { useEnvPropsStore } from './envProps';

const SEARCH_REGISTRY_RESULTS_ENDPOINT = '/regsvc/registry/api/v1/registry/search';

export const useSearchRegistryStore = defineStore('searchRegistry', {
  state: () => ({
    searchRegistryResults: [],
    registryResultsTableVisible: false,
    registryResultsLoading: false,
    selectedRegistryId: '',
    redirectSearchTerm: '',
    errorState: false,
    registrySearchTerm: '',
    searchRegistryApiErrorResponse: null,
    giftGiverToSearchPage: false,
    searchToGiftGiverPage: false,
    selectedRegistryGuid: '',
    registrySearchOccasion: '',
  }),
  actions: {
    [SET_SEARCH_REGISTRY_RESULTS](searchRegistryResults) {
      this.searchRegistryResults = searchRegistryResults;
    },
    [SET_GIFTGIVER_TO_SEARCHPAGE](giftGiverToSearchPage) {
      this.giftGiverToSearchPage = giftGiverToSearchPage;
    },
    [SET_SEARCH_TO_GIFTGIVERPAGE](searchToGiftGiverPage) {
      this.searchToGiftGiverPage = searchToGiftGiverPage;
    },
    [SET_REGISTRY_RESULTS_TABLE_VISIBILITY](registryResultsTableVisible) {
      this.registryResultsTableVisible = registryResultsTableVisible;
    },
    [SET_SELECTED_REGISTRY_ID](selectedRegistryId) {
      this.selectedRegistryId = selectedRegistryId;
    },
    [SET_SELECTED_REGISTRY_GUID](selectedRegistryGuid) {
      this.selectedRegistryGuid = selectedRegistryGuid;
    },
    [SET_REGISTRY_REDIRECT_SEARCH_TERM](searchTerm) {
      this.redirectSearchTerm = searchTerm;
    },
    clearRedirectSearchTerm() {
      this.redirectSearchTerm = '';
    },
    [SET_REGISTRY_RESULTS_LOADING](registryResultsLoading) {
      this.registryResultsLoading = registryResultsLoading;
    },
    [SET_SEARCH_REGISTRY_ERROR_STATE](errorState) {
      this.errorState = errorState;
    },
    [SET_REGISTRY_SEARCH_TERM](registrySearchTerm) {
      this.registrySearchTerm = registrySearchTerm;
    },
    [SEARCH_REGISTRY_API_ERROR_RESPONSE](error) {
      this.searchRegistryApiErrorResponse = error;
    },
    [SET_REGISTRY_SEARCH_OCCASION](occasion) {
      this.registrySearchOccasion = occasion;
    },
    async [GET_SEARCH_REGISTRY_RESULTS](params) {
      const envPropsStore = useEnvPropsStore();

      this[SET_REGISTRY_SEARCH_TERM](params.registrySearch);
      this[SET_SEARCH_REGISTRY_ERROR_STATE](false);
      this[SET_REGISTRY_RESULTS_TABLE_VISIBILITY](false);
      this[SET_REGISTRY_RESULTS_LOADING](true);
      const httpSource = $http.CancelToken.source();
      const timer = setTimeout(() => {
        this[SET_SEARCH_REGISTRY_RESULTS]([]);
        this[SET_SEARCH_REGISTRY_ERROR_STATE](true);
        this[SET_REGISTRY_RESULTS_LOADING](false);
        httpSource.cancel();
      }, envPropsStore.envProps?.apiTimeout || 0);
      try {
        const response = await $http.get(
          `${SEARCH_REGISTRY_RESULTS_ENDPOINT}?orgId=${params.orgId}&${
            validateRegistryId(params.registrySearch) ? 'registryId' : 'name'
          }=${params.registrySearch}${params.sortByOccasionType ? `&sortByOccasionType=${params.sortByOccasionType}` : ''}`,
          {
            headers: httpGetNonProtectedAPIHeaders({
              host: envPropsStore.envProps.siteDomain,
            }),
            cancelToken: httpSource.token,
          },
        );
        clearTimeout(timer);
        if (response?.data?.registryInfo) {
          this[SET_SEARCH_REGISTRY_RESULTS](response.data.registryInfo);
        } else {
          this[SET_SEARCH_REGISTRY_RESULTS]([]);
        }
      } catch (error) {
        clearTimeout(timer);
        this[SET_SEARCH_REGISTRY_RESULTS]([]);
        this[SET_SEARCH_REGISTRY_ERROR_STATE](true);
        this[SEARCH_REGISTRY_API_ERROR_RESPONSE](error);
      } finally {
        this[SET_REGISTRY_RESULTS_TABLE_VISIBILITY](true);
        this[SET_REGISTRY_RESULTS_LOADING](false);
      }
    },
  },
});
